import * as Reselect from 'reselect'
import * as R from 'ramda'

export const selectBooksFlaggedAsFreeTrial = Reselect.createSelector(
  R.pathOr([], ['freeTrial', 'bookIsFreeTrialFlags']),
  (bookIsFreeTrialFlags) => bookIsFreeTrialFlags
)
